import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class CreateNewPasswordGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const Code = localStorage.getItem('Code');
    const userEmail = localStorage.getItem('UserEmail');
    
    if(Code !== null && userEmail !== null){
      return true;
    }
    else{
      localStorage.clear();
      this.router.navigate(['/login']);
      return false;
    }
  }
};
